{
  "organization": "Organización",
  "tabs": {
    "apiTokens": "Tokens API",
    "embeddedWebApp": "Aplicación web integrada",
    "integrations": "Integraciones",
    "webHooks": "Webhooks"
  },
  "apiTokenTable": {
    "name": "Nombre",
    "noPermissions": "# de permisos",
    "organization": "Organización",
    "state": "Estado",
    "actions": "Acciones"
  },
  "apiTokenModal": {
    "title": "Crear nuevo token API",
    "name": "Nombre",
    "organization": "Organización",
    "permissions": "Permisos"
  },
  "viewApiToken": "Ver encabezado de autorización",
  "deactivate": "Desactivar",
  "deactivated": "Desactivado",
  "active": "Activo",
  "update": "Actualizar",
  "edit": "Editar",
  "cancel": "Cancelar",
  "editApiTokenModal": {
    "title": "Editar token API",
    "save": "Guardar"
  },
  "orgInfo": {
    "organizationId": "Identificación de la organización",
    "partnerJWK": "Socio JWK",
    "webAppURL": "URL de la aplicación web"
  },
  "integrationsTable": {
    "type": "Tipo",
    "name": "Nombre",
    "provider": "Proveedor",
    "organization": "Organización",
    "organizationSetting": "Configuración de la organización",
    "actions": "Acciones",
    "state": "Estado",
    "active": "Activo",
    "inactive": "Inactivo"
  },
  "integrationsTableOptions": {
    "type": {
      "ADDRESS": "Dirección",
      "ANALYTICS": "Análisis",
      "BANKING": "Banca",
      "FINANCIAL_DATA_WIDGETS": "Widgets de datos financieros",
      "ID_VERIFICATION": "Verificación de ID",
      "MARKET_DATA": "Datos de mercado",
      "DATA_INGESTION": "Ingestión de datos",
      "STATISTICS": "Estadísticas",
      "ACCOUNT_DETAILS": "Detalles de la cuenta",
      "FORM": "Formularios de integración",
      "CHAT_AGENT": "Agente de chat",
      "FRAUD_DETECTION": "Detección de fraudes",
      "PASSTHROUGH_API": "API de paso",
      "ACCOUNT_OPENING": "Apertura de cuenta"
    },
    "default": "Predeterminado",
    "provider": {
      "CANADA_POST": "Canada Post",
      "FLINKS": "Flinks",
      "PLAID": "Plaid",
      "GOOGLE": "Google",
      "FIREBASE": "Firebase",
      "IEX_CLOUD": "IEX Cloud",
      "LSEG": "LSEG",
      "MIXPANEL": "Mixpanel",
      "PERSONA": "Persona",
      "QUOTE_MEDIA": "Quote Media",
      "ENVESTNET": "Envestnet",
      "ATB": "ATB",
      "ONESPAN": "ONESPAN",
      "DOCUSIGN": "DOCUSIGN",
      "ZENDESK": "ZENDESK",
      "SIMILITY": "SIMILITY",
      "SCHWAB": "Schwab",
      "none": "Ninguno",
      "NBIN": "NBIN"
    },
    "organizationSetting": {
      "notInherited": "No heredado",
      "inherited": "Heredado"
    },
    "viewDataIngestionRequests": "Ver solicitudes"
  },
  "integrationsModal": {
    "title": "Crear nueva integración",
    "editTitle": "Editar integración",
    "provider": "Proveedor",
    "type": "Tipo",
    "configuration": {
      "clientIframeUrl": "URL del IFrame del cliente",
      "customerId": "Identificación del cliente",
      "processorName": "Nombre del procesador",
      "instanceId": "ID de instancia",
      "plaidSecret": "El secreto del plaid",
      "enableNameMatching": "Habilitar coincidencia de nombres",
      "templateId": "ID de plantilla",
      "verificationPassedWebhookSecret": "Secreto de Webhook de verificación superado",
      "inquiryUpdateWebhookSecret": "Actualización de la consulta Webhook secreto",
      "accountBaseUri": "URI base de la cuenta",
      "apiAccountId": "ID de cuenta API",
      "accountUserId": "ID de usuario de la cuenta",
      "integrationKey": "Clave de integración",
      "integrationRsaPrivateKey": "Integración de clave privada RSA",
      "connectSecretKey": "Clave secreta de Docusign Connect",
      "apiKey": "Clave API",
      "apiToken": "Token API",
      "TBD": "TBD",
      "user": "Usuario",
      "password": "Contraseña",
      "baseUrl": "URL base",
      "authDomain": "Dominio de autenticación",
      "projectId": "Identificación del proyecto",
      "messagingSenderId": "Identificador del remitente del mensaje",
      "appId": "ID de la aplicación",
      "measurementId": "Identificación de la medición",
      "privateKey": "Clave privada",
      "publicKey": "Clave pública",
      "username": "Nombre de usuario",
      "name": "Nombre",
      "widgetUsername": "Nombre de usuario de la API del widget",
      "widgetName": "Nombre de la API del widget",
      "widgetPrivateKey": "Clave privada de la API del widget",
      "widgetPublicKey": "Clave pública de la API del widget",
      "rdpUsername": "Nombre de usuario de la API RDP",
      "rdpPassword": "Contraseña de la API RDP",
      "rdpClientId": "ID de cliente de la API RDP",
      "webmasterId": "ID del webmaster",
      "clientRoleKey": "Clave de rol del cliente",
      "advisorRoleKey": "Clave de función del asesor",
      "pageKeys": "Claves de página",
      "fnclsValue": "Valor FNCLS",
      "scriptInjectURL": "URL de inyección de script",
      "token": "Token",
      "netWorthAutomaticLinkingUrl": "URL de enlace automático del patrimonio neto",
      "netWorthAutomaticLinkingToken": "Token de vinculación automática del patrimonio neto",
      "netWorthAutomaticLinkingNotificationGroup": "Grupo de notificación automática de vinculación del patrimonio neto",
      "senderEmail": "Correo electrónico del remitente",
      "packageNameTemplate": "Plantilla del nombre del paquete",
      "packageMetadataTemplate": "Plantilla de objeto de metadatos del paquete",
      "masterAccountIds": "ID de cuentas principales",
      "enableSftp": "Habilitar SFTP",
      "sftpHost": "Host SFTP",
      "sftpPort": "Puerto SFTP",
      "sftpUsername": "Nombre de usuario SFTP",
      "sftpPassword": "Contraseña SFTP",
      "sftpPrivateKey": "Clave privada SFTP",
      "sftpPassphrase": "Frase de contraseña SFTP",
      "sftpSendRootDir": "Directorio raíz de envío SFTP",
      "sftpReceiveRootDir": "Directorio raíz de recepción SFTP"
    },
    "attributes": {
      "passthroughApiUrl": "URL de la API de paso",
      "passthroughApiPrivateSecretName": "Nombre de variable de la clave privada utilizada para generar el token de autorización"
    },
    "scopeOptions": {
      "DATA_INGESTION": {
        "ORGANIZATION": "Organizaciones",
        "HOUSEHOLD": "Hogares",
        "ENTITY": "Entidades",
        "ORGANIZATION_USER": "Perfiles de autenticación",
        "ACCOUNT": "Cuentas",
        "SUB_ACCOUNT": "Subcuentas",
        "GOAL": "Metas",
        "TRANSACTION": "Transacciones",
        "CASH_AND_HOLDINGS": "Efectivo y activos",
        "ASSET_CLASS": "Clases de activos",
        "FINANCIAL_PRODUCT": "Estante de productos",
        "MODEL_PORTFOLIO": "Carteras modelo",
        "STATS_HISTORY": "Instantáneas históricas",
        "PRICE_HISTORY": "Instantáneas de precios",
        "PERFORMANCE_HISTORY": "Instantáneas de rendimiento",
        "TRANSFER": "Transferencias",
        "TRADE": "Transacciones",
        "SUB_TRADE": "Subtransacciones",
        "SCHEDULED_TRANSFER": "Transferencias programadas",
        "CUSTODIAN_ACTIVITY": "Actividades de custodia",
        "CUSTODIAN_CASH_AND_HOLDINGS": "Efectivo y activos en custodia",
        "BANK_ACCOUNT": "Cuentas bancarias",
        "ACCOUNT_GROUP": "Grupos de Cuentas"
      },
      "PASSTHROUGH_API": {
        "TRANSACTION": "Transacciones",
        "CASH_AND_HOLDINGS": "Efectivo y activos",
        "STATS_HISTORY": "Instantáneas históricas",
        "PROJECTED_INCOME": "Ingresos previstos",
        "PERFORMANCE": "Rendimiento",
        "LIVE_PRICING": "Precios en tiempo real",
        "HOUSEHOLD": "Hogares",
        "ENTITY": "Entidades",
        "ACCOUNT": "Cuentas",
        "PRODUCT_SHELF": "Estante de productos",
        "BANK_ACCOUNT": "Cuenta bancaria",
        "STATEMENT": "Estados de cuenta"
      },
      "STATISTICS": {
        "holdings": "Activos",
        "timeWeightedReturn": "Tasa de rendimiento ponderada por el tiempo (TWRR)",
        "moneyWeightedReturn": "Tasa de rendimiento ponderada por el dinero (MWRR)",
        "simpleRateOfReturn": "Tasa de rendimiento simple",
        "projectedIncome": "Ingresos previstos",
        "historySnapshots": "Instantáneas históricas",
        "contributions": "Contribuciones"
      }
    },
    "successToastMessage": "La integración se ha actualizado correctamente."
  },
  "integrationsDeleteModal": {
    "title": "¿Desea eliminar esta integración?",
    "body": "¿Estás seguro de que deseas eliminar esta integración?"
  },
  "webHooksTable": {
    "type": "Tipo",
    "objects": "Objetos",
    "organization": "Organización",
    "organizationSetting": "Configuración de la organización",
    "actions": "Acciones"
  },
  "webHooksTableOptions": {
    "type": {
      "GRAPHQL": "GraphQL",
      "REST": "REST"
    },
    "objectType": {
      "Account": "Cuenta",
      "AccountStatement": "Estado de cuenta",
      "AdministrativeAnnualFeeReport": "Informe sobre las tasas administrativas anuales",
      "BankAccount": "Cuenta bancaria",
      "ManagementAnnualFeeReport": "Informe anual sobre comisiones de gestión",
      "ScheduledTransfer": "Transferencia programada",
      "SubAccount": "Subcuenta",
      "TaxSlip": "Hoja de impuestos",
      "Transfer": "Transferencia",
      "User": "Usuario",
      "OrganizationUser": "Usuario de la organización",
      "BulkTradeRun": "Operación comercial a granel"
    }
  },
  "WebHookModal": {
    "title": "Crear nuevo webhook",
    "editTitle": "Editar webhook",
    "type": "Tipo",
    "organization": "Organización",
    "objectType": "Tipo de objeto",
    "customHeader": "Encabezado personalizado",
    "eventType": "Tipo de evento",
    "graphQL": "GraphQL",
    "url": "URL",
    "payloadAttributes": "Atributos de la carga útil",
    "signedJWTHeader": "Encabezado JWT firmado",
    "mutationName": "Nombre de la mutación",
    "mutationInputName": "Nombre de entrada de mutación",
    "customHeaderKey": "Clave de encabezado personalizada",
    "customHeaderValue": "Valor de encabezado personalizado",
    "payloadAttributeKey": "Clave de atributo de carga útil",
    "payloadAttributeValue": "Valor del atributo de carga útil",
    "successToastMessage": "WebHooks se ha actualizado correctamente.",
    "addAttributeBtn": "Añadir",
    "deleteSuccessToastMessage": "WebHook se ha eliminado correctamente",
    "delete": "Eliminar",
    "deleteWebHookTitle": "¿Está seguro?",
    "deleteWebHookBody": "No podrás recuperar este WebHook y tendrás que añadir otro."
  },
  "successToastMessage": "La URL de JWT se ha actualizado correctamente",
  "bulkUpsertRequest": {
    "table": {
      "objectType": "Tipo de objeto",
      "state": "Estado",
      "createdAt": "Se ejecutó en",
      "ranBy": "Ejecutado por",
      "queuedItemsCount": "En cola",
      "failedItemsCount": "Falló",
      "processedItemsCount": "Procesado"
    },
    "stateLabel": "Estado",
    "states": {
      "INITIATED": "Iniciado",
      "PROCESSING": "Procesando",
      "FAILED": "Falló",
      "PARTIALLY_FAILED": "Fallo parcial",
      "CANCELED": "Cancelado",
      "COMPLETED": "Completado"
    },
    "objectTypeLabel": "Tipo",
    "items": {
      "table": {
        "batchId": "ID del lote",
        "oneVestId": "ID de OneVest",
        "externalId": "Identificación externa",
        "state": "Estado"
      },
      "requestSummaryLine": "{{queued}} en cola / {{processed}} procesado / {{failed}} fallido",
      "states": {
        "QUEUED": "En cola",
        "PROCESSED": "Procesado",
        "FAILED": "Falló"
      },
      "upsertItemModal": {
        "title": "Detalles del artículo",
        "errorTitle": "Errores",
        "errorCode": "Código",
        "errorField": "Campo",
        "errorDescription": "Descripción",
        "summary": {
          "oneVestId": "ID de OneVest:",
          "batchId": "ID del lote:",
          "externalId": "Identificación externa:"
        }
      }
    }
  }
}
